import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@base/environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((platformRef) => {
    let mapsScript = document.createElement('script');
    mapsScript.type = 'text/javascript';
    mapsScript.async = true;
    mapsScript.defer = true;
    mapsScript.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      environment.googleAPIKey +
      '&libraries=places&loading=async';
    document.body.appendChild(mapsScript);
  })
  .catch((err) => console.error(err));
